export const TRANSACTION_TYPES = {
    ALL: 'ALL',
    INTRA_TRANSACTION: 1,
    INTERNATIONAL_TRANSACTION_SWIFT: 2,
    EXCHANGE_TRANSACTION: 3,
    ACH_TRANSACTION: 4,
    EFT_TRANSACTION: 5,
    EUROPE_TRANSACTION_SEPA: 6,
    BACS_TRANSACTION: 7,
    DOMESTIC_WIRE_TRANSACTION: 8,
    INTERNATIONAL_TRANSACTION_PAN_AFRICA: 9,
    CARD_TRANSACTION: 10,
    CRYPTO_TRANSACTION: 11,
    INTERAC_TRANSACTION: 12,
    BILL_PAYMENT_TRANSACTION: 13,
    EUROPE_TRANSACTION_SEPA_INSTANT: 14,
    FASTER_PAYMENT_TRANSACTION: 15,
    CHAPS_TRANSACTION: 16,
    IBERBANCO_FEE: 17,
} as const;

export const TRANSACTION_TYPE_LABELS = {
    [TRANSACTION_TYPES.ALL]: 'ALL',
    [TRANSACTION_TYPES.INTRA_TRANSACTION]: 'Intra Transaction',
    [TRANSACTION_TYPES.INTERNATIONAL_TRANSACTION_SWIFT]: 'International Transaction(SWIFT)',
    [TRANSACTION_TYPES.EXCHANGE_TRANSACTION]: 'Exchange Transaction',
    [TRANSACTION_TYPES.ACH_TRANSACTION]: 'ACH Transaction',
    [TRANSACTION_TYPES.EFT_TRANSACTION]: 'EFT Transaction',
    [TRANSACTION_TYPES.EUROPE_TRANSACTION_SEPA]: 'Europe Transaction (SEPA)',
    [TRANSACTION_TYPES.BACS_TRANSACTION]: 'BACS Transaction',
    [TRANSACTION_TYPES.DOMESTIC_WIRE_TRANSACTION]: 'Domestic Wire Transaction',
    [TRANSACTION_TYPES.INTERNATIONAL_TRANSACTION_PAN_AFRICA]: 'International Transaction (Pan Africa)',
    [TRANSACTION_TYPES.CARD_TRANSACTION]: 'Card Transaction',
    [TRANSACTION_TYPES.CRYPTO_TRANSACTION]: 'Crypto Transaction',
    [TRANSACTION_TYPES.INTERAC_TRANSACTION]: 'INTERAC Transaction',
    [TRANSACTION_TYPES.BILL_PAYMENT_TRANSACTION]: 'Bill Payment Transaction',
    [TRANSACTION_TYPES.EUROPE_TRANSACTION_SEPA_INSTANT]: 'Europe Transaction (SEPA INSTANT)',
    [TRANSACTION_TYPES.FASTER_PAYMENT_TRANSACTION]: 'Faster Payment Transaction',
    [TRANSACTION_TYPES.CHAPS_TRANSACTION]: 'CHAPS Transaction',
    [TRANSACTION_TYPES.IBERBANCO_FEE]: 'Iberbanco Fee',
} as const;

export type TransactionTypeValue = typeof TRANSACTION_TYPES[keyof typeof TRANSACTION_TYPES]; 